import { useEffect, useState } from "react";
import { Col, Form, Row } from "antd";
import { useDispatch } from "react-redux";
import Button from "components/Button/Button/Index"
import {request} from "lib/request"
import {GenericModal} from "components/Modal/Modal";
import Styles from './newsletter.module.scss';
import CDStyles from './consultingDoctors.module.scss'
import { cdn } from "core/cdn";
import { useLanguage } from "locales";
import ConsultingDoctors from "./ConsultingDoctors";
import profileActions from "containers/Profile/services/actions";

interface NewsletterStatusResponse {
    status: string;
    subscribed: boolean;
    has_valid_email: boolean;
}

interface NewsletterProps {
    onNavigateToInformations: () => void;
    active: boolean;
}

const Newsletter = ({ onNavigateToInformations, active }: NewsletterProps) => {
    const { languages } = useLanguage()
    const dispatch = useDispatch();
    const [subscribed, setSubscribed] = useState<boolean | undefined>(undefined);
    const [hasValidEmail, setHasValidEmail] = useState<boolean | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [showDoctorList, setShowDoctorList] = useState<boolean>(false);

    const applyStatus = (res: NewsletterStatusResponse) => {
        setSubscribed(res.subscribed);
        setHasValidEmail(res.has_valid_email);
    }

    // The Newsletter tab pane stays mounted (antd Tabs doesn't unmount inactive panes
    // by default), so a one-time fetch on mount would go stale if the customer adds an
    // email on the Informations tab and comes back here — refetch on every activation.
    useEffect(() => {
        if (!active) return;
        request<NewsletterStatusResponse>('/crm/newsletter/status', {method: "GET"})
            .then((res) => {
                if (res && res.status === "ok") applyStatus(res);
            })
            .catch((error) => console.error(error, { route: "/crm/newsletter/status" }))
    }, [active])

    const updateSubscription = (newSubscribed: boolean) => {
        setLoading(true);
        request<NewsletterStatusResponse>('/crm/newsletter/subscription', {
            method: "POST",
            payload: { subscribed: newSubscribed },
        })
            .then((res) => {
                if (res && res.status === "ok") {
                    applyStatus(res);
                    dispatch(profileActions.changePatientSuccess(
                        newSubscribed ? languages.newsletterSubscribeSuccess : languages.newsletterUnsubscribeSuccess
                    ));
                }
            })
            .catch((error) => {
                console.error(error, { route: "/crm/newsletter/subscription" });
                dispatch(profileActions.changePatientError(languages.newsletterUpdateError));
            })
            .finally(() => setLoading(false));
    }

    return (
        <div>
            <GenericModal visible={showDoctorList} footer={undefined} bodyStyle={{ height: 600 }}>
                <div>
                    <div style={{textAlign: "right"}} onClick={() => setShowDoctorList(false)}>
                        <img src={cdn("/images/close_pop-up.svg")} alt="close_icon" style={{paddingBottom: "40px"}}/>
                    </div>
                    <ConsultingDoctors />
              </div>
            </GenericModal>
            <GenericModal visible={showAlertModal}
                title={
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                        <img src={cdn("/images/picto_warning.svg")} alt="Attention - icône" width={75} height={75} />
                        <span>{languages.newsletterUnsubscribeConfirmTitle}</span>
                    </div>
                }
                contentText={languages.newsletterUnsubscribeConfirmText}
                bodyStyle={{ textAlign: "center" }}
                onCancel={() => {
                    setShowAlertModal(false);
                }}
                cancelText={languages.cancel}
                cancelButtonProps={{type: "primary"}}
                acceptText={languages.newsletterUnsubscribeConfirmAccept}
                loading={loading}
                onAccept={() => {
                    updateSubscription(false);
                    setShowAlertModal(false);
                }}
            />
            <Form>
            <Row gutter={[16, 16]} align="middle">
          {hasValidEmail === false ? (
            <Col span="23">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "1551px", gap: "30px" }}>
                <p style={{ fontSize: "28px", color: "#211452", textAlign: "left", margin: 0 }}>
                  {languages.newsletterNoValidEmailMessage}
                </p>
                <Button onClick={onNavigateToInformations} style={{ width: "486px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  {languages.newsletterAddEmailCta}
                </Button>
              </div>
            </Col>
          ) : (
            <>
              <Col span="23">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ fontSize: "28px", color: "#211452" }}>{languages.subscribePlaceholder}</div>
                  <div className={Styles.buttonContainer}>
                      <Button
                              disabled={loading || subscribed === undefined || !subscribed}
                              style={subscribed === false ? { backgroundColor: "#d64949", borderColor: "#d64949", color: "#fff" } : undefined}
                              onClick={() => {
                                  setShowAlertModal(true);
                              }}>
                              {languages.no}
                          </Button>
                          <Button style={{
                                  marginLeft: "25px",
                                  ...(subscribed === true ? { backgroundColor: "#3889c8", borderColor: "#3889c8", color: "#fff" } : {}),
                              }}
                              onClick={() => updateSubscription(true)}
                              loading={loading}
                              disabled={loading || subscribed === undefined || subscribed}
                          >
                                  {languages.yes}
                          </Button>
                  </div>
                </div>
              </Col>
              <Col span="19">
                <Form.Item>
                  <div className={CDStyles.DoctorAvailableButton}>
                    <img src={cdn("/icons/i_picto_blue.svg")} alt="info" width={75} height={75} />
                    <span
                      className={CDStyles.DoctorTitle}
                      dangerouslySetInnerHTML={{ __html: languages.newsletterHealthInfo_html }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </>
          )}
          <Col span="19">
            <Form.Item>
              <div className={CDStyles.DoctorAvailableButton} onClick={() => setShowDoctorList(true)}>
                <img src={cdn('/images/consulting_doctors.svg')} alt="consulting doctors" />
                <span className={CDStyles.DoctorTitle}>{languages.listOfHealthProfessionals}</span>
              </div>
            </Form.Item>
          </Col>
        </Row>
            </Form>
        </div>
    );
};

export default Newsletter;
